import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/WeblinksExample.css';

const verifyLinkSuffixes = ['Email', 'Email Address', 'Email ID'];

const WeblinksExample = () => {
    const [verifyLinkSuffix] = useState(
        () => verifyLinkSuffixes[Math.floor(Math.random() * verifyLinkSuffixes.length)]
    );

    return (
        <div className="weblinks-example-container">
            <h1>Web Links Example</h1>
            <p>Explore various web links below:</p>
            <ul>
                <li>
                    <Link to="/forgotpasswords" className="web-link">
                        Reset password
                    </Link>
                </li>
                <li>
                    <Link to="/verify-email" className="web-link">
                        Verify {verifyLinkSuffix}
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default WeblinksExample;
